import { Card, CardContent, Grid, Typography } from '@mui/material';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useDenuncias } from './hooks/useDenuncias';
import { Fragment, useEffect } from 'react';
import { EstadoSolicitudDenuncia } from './components/EstadoSolicitudDenuncia';
import { PreviewBox } from '../Common/PreviewBox';
import { PreviewField } from '../Common/PreviewField';
import { PreviewFieldContainer } from '../Common/PreviewFieldContainer';
import { PreviewFileField } from '../Common/PreviewFileField';

// (formatNumber removed — not used in this component)

const formatDate = (value = null) => {
  if (!value) {
    return;
  }
  const date = new Date(value);
  const result = new Intl.DateTimeFormat('es-AR').format(date);
  return result;
};

export const DENUNCIA_CODIGO_ESTADO_APROBADO = '4';

export const ShowDenuncia = () => {
  const history = useHistory();
  const { denuncia: denunciaSelected } = history?.location?.state || {};
  const { getDenuncia, denuncia, documentacionList } = useDenuncias();

  useEffect(() => {
    if (denunciaSelected?.id) {
      getDenuncia(denunciaSelected.id);
    }
  }, []);

  return (
    <div className='container'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonBack marginBottom='1' variant='text' size='small' />
          <Card sx={{ width: '100%', p: 1, paddingX: { xs: 0, sm: 1 } }}>
            <CardContent>
              <Grid container spacing={1} rowSpacing={1} gap={1}>
                <Grid item>
                  <Typography variant='h5' component={'span'}>
                    Consulta de Solicitud de Reclamo
                  </Typography>
                </Grid>
                {denuncia?.estado?.codigoEstado && (
                  <Grid item xs={12}>
                    <EstadoSolicitudDenuncia estadoSolicitud={denuncia.estado} />
                  </Grid>
                )}

                {denuncia && (
                  <>
                    {/* Solicitud de reclamo */}
                    <Grid item xs={12}>
                      <PreviewBox title='Solicitud de Reclamo' alignItems='center'>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='id'
                            label='Número'
                            value={denuncia.solicitudCobertura.idSolicitudCoberturaFormateado}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='tipoTramite'
                            label='Tipo de Trámite'
                            value={denuncia.tipoCobertura.descripcion}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='fechaDeSolicitud'
                            label='Fecha de Solicitud'
                            value={formatDate(denuncia.solicitudCobertura.fechaGenerada) || '-'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='estadoActual'
                            label='Estado'
                            value={denuncia.estado.descripcionEstadoSolicitudCobertura}
                          />
                        </Grid>
                        {denuncia.estado.codigoEstado === DENUNCIA_CODIGO_ESTADO_APROBADO && (
                          <>
                            {/* <Grid item xs={12} sm={6}>
                          <PreviewFieldContainer>
                            <PreviewFileField
                              id='formatted-text-mask-input'
                              label={
                                'Providencia ' +
                                formatNumber(denuncia.estado.idHistorialEstadoSolicitudCobertura)
                              }
                              href={denuncia.providenciaUrl}
                            />
                          </PreviewFieldContainer>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <PreviewField
                            id='fechaInicio'
                            label='Inicio Vigencia'
                            value={formatDate(denuncia.solicitudCobertura.fechaIniciada) || '-'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <PreviewField
                            id='fechaVencimiento'
                            label='Vencimiento'
                            value={formatDate(denuncia.solicitudCobertura.vencimiento) || '-'}
                          />
                        </Grid> */}
                          </>
                        )}
                      </PreviewBox>
                    </Grid>

                    {/* Archivos adjuntos */}
                    <Grid item xs={12}>
                      <PreviewBox title='Documentación Presentada'>
                        {documentacionList?.length > 0 &&
                          documentacionList.map((grupo) => {
                            if (grupo?.documentos?.length === 0) {
                              return null;
                            }

                            return (
                              <Fragment key={grupo.codigo}>
                                {grupo.documentos.map((doc, idx) => {
                                  return (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      key={doc.idHistorialDocumentacionSolicitudCobertura}
                                    >
                                      <PreviewFieldContainer>
                                        <PreviewFileField
                                          label={`${doc.documentacion} - ${idx + 1}`}
                                          src={doc?.path || ''}
                                        />
                                      </PreviewFieldContainer>
                                    </Grid>
                                  );
                                })}
                              </Fragment>
                            );
                          })}
                      </PreviewBox>
                    </Grid>

                    {/* Datos del afiliado */}
                    <Grid item xs={12}>
                      <PreviewBox title='Afiliado'>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='dni'
                            label='Documento'
                            value={`${denuncia.afiliado.numeroDocumentoFormateado}`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='nya'
                            label='Apellido y Nombre'
                            value={`${denuncia.afiliado.apellidoNombreFormateado}`}
                          />
                        </Grid>
                      </PreviewBox>
                    </Grid>

                    {/* Reclamo */}
                    <Grid item xs={12}>
                      <PreviewBox title={'Motivo del Reclamo'}>
                        <Grid item xs={12}>
                          <PreviewField
                            id='observaciones'
                            label={''}
                            value={
                              denuncia?.estado?.observacion
                                ? `${denuncia.estado.observacion[0].toUpperCase()}${denuncia.estado.observacion.slice(
                                    1,
                                  )}`
                                : '-'
                            }
                            multiline
                          />
                        </Grid>
                      </PreviewBox>
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
